function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Document, Link, Page, Path, StyleSheet, Svg, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { formatNumber } from '../../utils/formatNumber';
var styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFAF5',
        paddingTop: '50px',
        paddingBottom: '50px',
        paddingLeft: '20px',
        paddingRight: '20px',
        fontSize: 10
    },
    header: {
        width: '100%',
        height: '91px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '24px',
        marginTop: '24px',
        alignItems: 'center'
    },
    logo: {
        display: 'flex',
        width: 189,
        height: 65
    },
    contact: {
        position: 'relative',
        fontWeight: 600,
        border: '1px solid #ff5055',
        borderRadius: '99999px',
        color: 'white',
        padding: '12px 26px 12px 26px',
        backgroundColor: '#ff5055'
    },
    container: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '24px',
        padding: '0px 10px 0px 10px'
    },
    content: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '32px',
        backgroundColor: '#ebe4d5',
        padding: '30px 10px 30px 10px',
        gap: '40px'
    },
    title: {
        width: '100%',
        fontWeight: 700,
        fontSize: 14,
        lineHeight: 1.2
    },
    text: {
        width: '100%',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 1.4
    },
    table: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '16px',
        overflow: 'hidden',
        borderCollapse: 'collapse'
    },
    th: {
        fontWeight: 700,
        fontSize: 10,
        color: 'white',
        backgroundColor: '#3a8574',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px 0px'
    },
    tr: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '4px',
        borderTop: '1px solid #3a8574'
    },
    td: {
        fontSize: 10,
        padding: '4px',
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        color: 'black'
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '4px 2px'
    }
});
export var LegacySimulatorResultDocument = function LegacySimulatorResultDocument(param) {
    var t = param.t, data = param.data;
    var _data_dataWithLegacy;
    return /*#__PURE__*/ React.createElement(Document, null, /*#__PURE__*/ React.createElement(Page, {
        size: "A4",
        style: styles.page
    }, /*#__PURE__*/ React.createElement(View, {
        style: styles.header
    }, /*#__PURE__*/ React.createElement(Svg, {
        width: "189",
        height: "65",
        fill: "none",
        style: styles.logo
    }, /*#__PURE__*/ React.createElement(Path, {
        fill: "orange",
        d: "M22.43 53.682c.015-6.154-4.892-11.17-10.936-11.185C5.444 42.483.514 47.48.5 53.634c-.014 6.155 4.897 11.17 10.944 11.185 6.046.012 10.972-4.982 10.986-11.137Z"
    }), /*#__PURE__*/ React.createElement(Path, {
        fill: "#004E9C",
        d: "M87.792 17.35v22.375h-3.556v-2.08c-1.244 1.54-3.081 2.292-5.243 2.292-4.594 0-8-3.257-8-8.263 0-5.007 3.409-8.232 8-8.232 2.043 0 3.852.694 5.096 2.171V17.35h3.703Zm-3.646 14.324c0-3.076-2.043-5.038-4.712-5.038-2.669 0-4.712 1.96-4.712 5.038 0 3.078 2.043 5.037 4.712 5.037 2.669 0 4.712-1.959 4.712-5.037ZM103.258 34.178l2.608 2.413c-1.837 2.2-4.267 3.317-7.17 3.317-5.069 0-8.475-3.317-8.475-8.263s3.172-8.264 8.178-8.295c4.622-.03 7.675 2.835 7.851 7.48l-11.023 2.955c.683 1.568 2.044 2.504 3.793 2.504 1.541 0 3.022-.724 4.238-2.111Zm-8.474-3.165 6.993-1.93c-.503-1.569-1.6-2.293-3.141-2.293-2.28 0-3.733 1.477-3.852 4.223ZM126.755 18.614h-9.066v21.11h9.066c6.725 0 11.319-4.221 11.319-10.555 0-6.333-4.592-10.555-11.319-10.555Zm7.436 10.555c0 4.372-2.991 7.238-7.613 7.238h-5.037V21.931h5.037c4.622 0 7.613 2.866 7.613 7.238ZM155.164 23.62v16.105h-3.527v-2.051c-1.185 1.477-3.053 2.263-5.096 2.263-4.058 0-6.815-2.263-6.815-7.117v-9.198h3.702v8.686c0 2.924 1.363 4.314 3.703 4.314 2.579 0 4.326-1.629 4.326-4.854v-8.143h3.702l.005-.005ZM167.371 39.725l6.784-16.105h-3.551l-5.068 11.943-4.918-11.943h-3.852l6.784 16.105h3.821ZM185.509 34.178l2.607 2.413c-1.837 2.2-4.267 3.317-7.17 3.317-5.068 0-8.474-3.317-8.474-8.263s3.171-8.264 8.178-8.295c4.622-.03 7.675 2.835 7.85 7.48l-11.022 2.955c.683 1.568 2.043 2.504 3.793 2.504 1.54 0 3.022-.724 4.238-2.111Zm-8.474-3.165 6.992-1.93c-.502-1.569-1.6-2.293-3.14-2.293-2.281 0-3.734 1.477-3.852 4.223ZM76.09 43.706h-2.964v21.11h2.963v-21.11ZM95.704 64.817H92.86V55.95c0-3.136-1.54-4.676-4.238-4.676-3.022 0-4.978 1.839-4.978 5.308v8.232H80.8V48.83h2.726v2.413c1.156-1.629 3.171-2.562 5.66-2.562 3.82 0 6.518 2.231 6.518 6.936v9.2ZM98.254 63.124l-.002.004v-.005l.002.001ZM98.254 63.124l1.183-2.288c1.332.965 3.466 1.66 5.511 1.66 2.636 0 3.734-.816 3.734-2.172 0-1.54-1.826-1.847-3.912-2.199-2.778-.468-6.016-1.013-6.016-4.648 0-2.866 2.518-4.796 6.548-4.796 2.043 0 4.356.543 5.717 1.447l-1.214 2.292c-1.422-.936-2.991-1.266-4.532-1.266-2.489 0-3.702.936-3.702 2.2 0 1.65 1.909 1.989 4.055 2.369 2.755.488 5.9 1.045 5.9 4.536 0 2.895-2.607 4.734-6.784 4.734-2.606 0-5.184-.815-6.488-1.869ZM123.762 63.883c-.858.753-2.162 1.115-3.437 1.115-3.172 0-4.978-1.781-4.978-5.007v-8.777h-2.667V48.83h2.667v-3.498h2.844v3.498h4.504v2.384h-4.504v8.657c0 1.717.889 2.682 2.461 2.682.829 0 1.631-.27 2.223-.752l.889 2.08-.002.002ZM127.552 41.986c-1.095 0-1.924.843-1.925 1.9.001 1.053.801 1.868 1.925 1.868 1.123 0 1.925-.844 1.925-1.93 0-1.023-.83-1.838-1.925-1.838ZM128.974 48.833h-2.844v15.984h2.844V48.833ZM142.279 63.883c-.859.753-2.162 1.115-3.437 1.115-3.172 0-4.978-1.781-4.978-5.007v-8.777h-2.667V48.83h2.667v-3.498h2.844v3.498h4.504v2.384h-4.504v8.657c0 1.717.889 2.682 2.461 2.682.829 0 1.63-.27 2.223-.752l.889 2.08-.002.002ZM158.783 64.817V48.833h-2.844v8.263c0 3.438-1.896 5.308-4.859 5.308-2.698 0-4.239-1.568-4.239-4.705v-8.866h-2.844v9.197c0 4.704 2.697 6.968 6.755 6.968 2.224 0 4.177-.934 5.334-2.594v2.413h2.697ZM172.145 63.883c-.858.753-2.162 1.115-3.437 1.115-3.172 0-4.978-1.781-4.978-5.007v-8.777h-2.667V48.83h2.667v-3.498h2.844v3.498h4.504v2.384h-4.504v8.657c0 1.717.889 2.682 2.461 2.682.829 0 1.631-.27 2.223-.752l.889 2.08-.002.002ZM187.286 62.406l-1.54-1.87c-1.155 1.299-2.695 1.93-4.532 1.93-2.639 0-4.592-1.268-5.393-3.469l12.473-2.473c-.088-4.765-3.437-7.84-7.732-7.84-4.563 0-7.882 3.374-7.882 8.142 0 4.767 3.376 8.174 8.444 8.174 2.607 0 4.769-.905 6.162-2.594Zm-11.851-5.428v-.302h.002c0-3.349 2.133-5.549 5.125-5.549 2.548 0 4.416 1.629 4.918 3.92l-10.045 1.93ZM25.47 41.093c.014-6.155 4.944-11.15 10.99-11.137h.09V17.415h-.063c-12.84-.03-23.313 10.582-23.341 23.651 0 .528.021 1.052.054 1.573 5.234.85 9.24 5.482 9.228 11.045a11.247 11.247 0 0 1-1.31 5.263c4.086 3.64 9.424 5.86 15.267 5.872.054 0 .109-.005.166-.005V52.273l-.138.002c-6.047-.012-10.958-5.03-10.944-11.185"
    }), /*#__PURE__*/ React.createElement(Path, {
        fill: "#FF5055",
        d: "M59.938 23.753C59.967 10.686 49.544.029 36.707 0c-.052 0-.105.002-.157.005v12.54l.13-.002c6.047.015 10.952 5.031 10.937 11.186-.011 6.154-4.937 11.149-10.984 11.137h-.08v12.54h.054c12.838.03 23.305-10.581 23.334-23.65"
    }), /*#__PURE__*/ React.createElement(Path, {
        fill: "#5DB3E6",
        d: "M13.203 42.637a23.802 23.802 0 0 0 7.916 16.307 11.253 11.253 0 0 0 1.311-5.262c.012-5.561-3.994-10.194-9.227-11.045Z"
    })), /*#__PURE__*/ React.createElement(Link, {
        href: "mailto:legs@deduveinstitute.be",
        style: _object_spread_props(_object_spread({}, styles.contact), {
            marginLeft: 'auto'
        })
    }, t('contact'))), /*#__PURE__*/ React.createElement(View, {
        style: styles.container
    }, /*#__PURE__*/ React.createElement(View, {
        style: styles.content
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.text), {
            textAlign: 'center'
        })
    }, t('export_description')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.text), {
            textAlign: 'center'
        })
    }, t('export_description2'))), data.dataWithLegacy.length > 0 && /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%',
            textAlign: 'left',
            marginBottom: 10
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.title)
    }, t('simulation-result'), " ", t(data.region))), /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%',
            textAlign: 'left'
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.title)
    }, t('with-legacy-as-a-duo')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.text)
    }, t('compare-the-advantage-for-each-inheritance-with-duo-legacy'))), /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.table), {
            width: '100%',
            marginTop: 10
        })
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.tableRow), {
            backgroundColor: '#3a8574'
        })
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, ' '), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('legacy')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('inheritance-rights')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('net')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('advantage'))), /*#__PURE__*/ React.createElement(View, null, data === null || data === void 0 ? void 0 : (_data_dataWithLegacy = data.dataWithLegacy) === null || _data_dataWithLegacy === void 0 ? void 0 : _data_dataWithLegacy.map(function(item) {
        return /*#__PURE__*/ React.createElement(View, {
            style: _object_spread({}, styles.tr)
        }, /*#__PURE__*/ React.createElement(View, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            })
        }, /*#__PURE__*/ React.createElement(View, {
            style: _object_spread({
                textAlign: 'left'
            }, item.relation === 'duve-institute' && {
                alignItems: 'flex-start',
                justifyContent: 'flex-start'
            })
        }, /*#__PURE__*/ React.createElement(Text, null, t(item.relation)), /*#__PURE__*/ React.createElement(Text, {
            style: {
                opacity: 0.5
            }
        }, item.name))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread(_object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            }), item.relation === 'duve-institute' && {
                alignItems: 'flex-start',
                justifyContent: 'flex-start'
            })
        }, formatNumber(Number(item.legacy))), !item['inheritance-rights'] ? /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                textAlign: 'left',
                width: '20%'
            })
        }, "/") : /*#__PURE__*/ React.createElement(View, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                textAlign: 'left'
            })
        }, item['inheritance-rights'].map(function(right) {
            return /*#__PURE__*/ React.createElement(View, {
                style: {
                    marginTop: '2px',
                    textAlign: 'left'
                }
            }, /*#__PURE__*/ React.createElement(Text, null, "-", formatNumber(Number(right.value))), /*#__PURE__*/ React.createElement(Text, {
                style: {
                    opacity: 0.8
                }
            }, t('droits_de'), " ", t(right.relationship)));
        })), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread(_object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            }), item.relation === 'duve-institute' && {
                alignItems: 'flex-start',
                justifyContent: 'flex-start'
            })
        }, formatNumber(Number(item.net))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread(_object_spread_props(_object_spread({}, styles.td), {
                width: '20%',
                color: Number(item.advantage) > 0 ? '#3a8574' : '#ff5055'
            }), item.relation === 'duve-institute' && {
                alignItems: 'flex-start',
                justifyContent: 'flex-start'
            })
        }, Number(item.advantage) > 0 ? '+' : '', formatNumber(Number(item.advantage))));
    }))))), data.dataWithoutLegacy.length > 0 && /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%',
            textAlign: 'left'
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.title)
    }, t('without-legacy-as-a-duo')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.text)
    }, t('compare-the-advantage-for-each-inheritance-without-duo-legacy'))), /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.table), {
            width: '100%',
            marginTop: 10
        })
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.tableRow), {
            backgroundColor: '#3a8574'
        })
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('legacy')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('inheritance-rights')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    }, t('net')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '20%'
        })
    })), /*#__PURE__*/ React.createElement(View, null, data.dataWithoutLegacy.map(function(item) {
        return /*#__PURE__*/ React.createElement(View, {
            style: _object_spread({}, styles.tr)
        }, /*#__PURE__*/ React.createElement(View, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            })
        }, /*#__PURE__*/ React.createElement(View, {
            style: {
                textAlign: 'left'
            }
        }, /*#__PURE__*/ React.createElement(Text, null, t(item.relation)), /*#__PURE__*/ React.createElement(Text, {
            style: {
                opacity: 0.5
            }
        }, item.name))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            })
        }, formatNumber(Number(item.legacy))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            })
        }, !item['inheritance-rights'] ? '/' : formatNumber(Number(item['inheritance-rights']))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%'
            })
        }, !item.net ? '/' : formatNumber(Number(item.net))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '20%',
                color: '#ff5055'
            })
        }, !item.advantage ? '' : item.advantage === '/' ? item.advantage : Number(item.advantage) > 0 ? "+".concat(formatNumber(Number(item.advantage))) : "".concat(formatNumber(Number(item.advantage)))));
    }))))), data.dataWithoutDuo.length > 0 && /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%',
            textAlign: 'left'
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread({}, styles.title)
    }, t('simulation-result'), " ", t(data.region))), /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.table), {
            width: '100%',
            marginTop: 10
        })
    }, /*#__PURE__*/ React.createElement(View, {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.tableRow), {
            backgroundColor: '#3a8574'
        })
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '25%'
        })
    }), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '25%'
        })
    }, t('legacy')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '25%'
        })
    }, t('inheritance-rights')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.th), {
            width: '25%'
        })
    }, t('net'))), /*#__PURE__*/ React.createElement(View, null, data.dataWithoutDuo.map(function(item) {
        return /*#__PURE__*/ React.createElement(View, {
            style: _object_spread({}, styles.tr)
        }, /*#__PURE__*/ React.createElement(View, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '25%'
            })
        }, /*#__PURE__*/ React.createElement(View, {
            style: {
                textAlign: 'left'
            }
        }, /*#__PURE__*/ React.createElement(Text, null, t(item.relation)), /*#__PURE__*/ React.createElement(Text, {
            style: {
                opacity: 0.5
            }
        }, item.name))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '25%'
            })
        }, formatNumber(Number(item.legacy))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '25%'
            })
        }, !item['inheritance-rights'] ? '/' : formatNumber(Number(item['inheritance-rights']))), /*#__PURE__*/ React.createElement(Text, {
            style: _object_spread_props(_object_spread({}, styles.td), {
                width: '25%'
            })
        }, !item.net ? '/' : formatNumber(Number(item.net))));
    })))))), /*#__PURE__*/ React.createElement(View, {
        style: _object_spread_props(_object_spread({}, styles.content), {
            gap: '10px',
            marginTop: '30px'
        })
    }, /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.title), {
            textAlign: 'center'
        })
    }, t('contact')), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.text), {
            textAlign: 'center'
        })
    }, "".concat(t('by-email'), " : "), /*#__PURE__*/ React.createElement(Link, {
        href: "mailto:legs@deduveinstitute.be"
    }, "legs@deduveinstitute.be")), /*#__PURE__*/ React.createElement(Text, {
        style: _object_spread_props(_object_spread({}, styles.text), {
            textAlign: 'center'
        })
    }, "".concat(t('or-by-phone'), " "), /*#__PURE__*/ React.createElement(Link, {
        href: "tel:+3227647334"
    }, "+32 2 764 73 34"), " (".concat(t('direct-line'), ")"))))));
};

//# sourceMappingURL=LegacySimulatorResultDocument.js.map